"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrometheusEditorContainer = void 0;
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var react_redux_1 = require("react-redux");
var Localize_1 = require("../../gen-src/Localize");
var RootReducer_1 = require("../app/RootReducer");
var MegaphoneAnnounce_1 = require("../img/MegaphoneAnnounce");
var PredictiveModelSlice_1 = require("../store/slice/PredictiveModelSlice");
var PredictiveModelThunk_1 = require("../store/thunk/PredictiveModelThunk");
var styles = require("../styles/LayoutStyles");
var TestIds_1 = require("../util/TestIds");
var Utils_1 = require("../util/Utils");
var ConnectToDataSubspace_1 = require("./ConnectToDataSubspace");
var DefineObjectiveSubspace_1 = require("./DefineObjectiveSubspace");
var DeployModelSubspace_1 = require("./DeployModelSubspace");
var ModelResultSubspace_1 = require("./ModelResultSubspace");
var PrometheusEditorHeader_1 = require("./PrometheusEditorHeader");
var StateSelectors_1 = require("./StateSelectors");
var TrainModelSubspace_1 = require("./TrainModelSubspace");
var Index_1 = require("./base/Index");
var NavigationContext_1 = require("./base/NavigationContext");
var EDITOR_URL = '/predictive-model-editor';
var FEEDBACK_URL = 'https://prerelease.tableau.com/';
var PrometheusEditorContainer = function (props) {
    var prepEmbeddingProps = props.prepEmbeddingProps;
    var modelLoadStatus = (0, RootReducer_1.useAppSelector)(PredictiveModelSlice_1.selectModelLoadStatus);
    var dispatch = (0, react_redux_1.useDispatch)();
    var thunkDispatch = (0, RootReducer_1.useAppThunkDispatch)();
    var selectSubspace = (0, RootReducer_1.useAppSelector)(StateSelectors_1.subspaceSelector);
    var prepDataSourceStatus = (0, RootReducer_1.useAppSelector)(StateSelectors_1.selectPrepDataSourceStatus);
    var modelTraining = (0, RootReducer_1.useAppSelector)(PredictiveModelSlice_1.selectModelTraining);
    var modelSucceededTraining = (0, RootReducer_1.useAppSelector)(PredictiveModelSlice_1.selectModelSucceededTraining);
    var model = (0, RootReducer_1.useAppSelector)(PredictiveModelSlice_1.selectModel);
    var job = (0, RootReducer_1.useAppSelector)(PredictiveModelSlice_1.selectJob);
    var userId = String(job.jobOwnerId);
    var userName = (0, RootReducer_1.useAppSelector)(PredictiveModelSlice_1.selectTrainingJobUsername);
    var loadEditor = function () { return __awaiter(void 0, void 0, void 0, function () {
        var index, luid, deployedVersion;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (modelLoadStatus.status !== Utils_1.REDUX_STATUS.idle) {
                        return [2 /*return*/];
                    }
                    if (!window.location.href.endsWith(EDITOR_URL)) return [3 /*break*/, 1];
                    dispatch((0, PredictiveModelThunk_1.createModel)());
                    return [3 /*break*/, 8];
                case 1:
                    index = window.location.href.indexOf(EDITOR_URL) + EDITOR_URL.length + 1;
                    if (!(index < window.location.href.length)) return [3 /*break*/, 8];
                    luid = window.location.href.substring(index);
                    return [4 /*yield*/, thunkDispatch((0, PredictiveModelThunk_1.editModel)({ luid: luid })).unwrap()];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, thunkDispatch((0, PredictiveModelThunk_1.getRecentTrainingJob)()).unwrap()];
                case 3:
                    _a.sent();
                    return [4 /*yield*/, thunkDispatch((0, PredictiveModelThunk_1.getDeployedVersion)()).unwrap()];
                case 4:
                    deployedVersion = _a.sent();
                    if (!deployedVersion) return [3 /*break*/, 6];
                    return [4 /*yield*/, thunkDispatch((0, PredictiveModelThunk_1.getLatestDeploymentByVersionLuid)({ versionLuid: deployedVersion.luid })).unwrap()];
                case 5:
                    _a.sent();
                    _a.label = 6;
                case 6: return [4 /*yield*/, thunkDispatch((0, PredictiveModelSlice_1.setInitialSubspace)()).unwrap()];
                case 7:
                    _a.sent();
                    _a.label = 8;
                case 8: return [2 /*return*/];
            }
        });
    }); };
    React.useEffect(function () {
        void loadEditor();
    }, []);
    React.useEffect(function () {
        if (userId) {
            dispatch((0, PredictiveModelThunk_1.getTrainingJobUsername)({ userId: userId }));
        }
    }, [dispatch, userId]);
    // Added check for EDITOR_URL because that's only missing in local dev mode.
    // This unblocks fast local testing using yarn dev.
    if (window.location.href.includes(EDITOR_URL) &&
        [Utils_1.REDUX_STATUS.idle, Utils_1.REDUX_STATUS.loading].includes(modelLoadStatus.status) &&
        !model.luid) {
        return React.createElement(Index_1.Loader, null);
    }
    if (modelLoadStatus.status === Utils_1.REDUX_STATUS.failed) {
        return React.createElement("span", null, modelLoadStatus.error);
    }
    var renderSubspaceConnectComponent = function (subspace) {
        var displayStyle = { display: subspace === Utils_1.SubspaceType.Connect ? 'flex' : 'none' };
        return (React.createElement("div", { className: styles.predictiveModelEditorContainer, style: displayStyle },
            React.createElement(ConnectToDataSubspace_1.ConnectToDataSubspace, { prepEmbeddingProps: prepEmbeddingProps })));
    };
    var renderSubspaceNonConnectComponent = function (subspace) {
        if (subspace === Utils_1.SubspaceType.Connect) {
            return null;
        }
        var subspaceComponent;
        var containerCss = [styles.predictiveModelEditorContainer];
        switch (subspace) {
            case Utils_1.SubspaceType.Define:
                subspaceComponent = React.createElement(DefineObjectiveSubspace_1.DefineObjectiveSubspace, null);
                break;
            case Utils_1.SubspaceType.Train:
                subspaceComponent = React.createElement(TrainModelSubspace_1.TrainModelSubspace, { server: props.server });
                break;
            case Utils_1.SubspaceType.Results:
                containerCss.push(styles.predictiveModelEditorModelResultContainer);
                subspaceComponent = React.createElement(ModelResultSubspace_1.default, { server: props.server });
                break;
            case Utils_1.SubspaceType.Deploy:
                subspaceComponent = (React.createElement("div", { className: styles.predictiveModelEditorDeployBackground },
                    React.createElement(DeployModelSubspace_1.DeployModelSubspace, { server: props.server }),
                    ";"));
                break;
            default:
                subspaceComponent = React.createElement(ConnectToDataSubspace_1.ConnectToDataSubspace, null);
                break;
        }
        return React.createElement("div", { className: containerCss.join(' ') }, subspaceComponent);
    };
    var openFeedbackWindow = function () {
        window.open(FEEDBACK_URL, '_blank');
    };
    var renderSubmitFeedbackButton = function () {
        return (React.createElement("div", { className: styles.submitFeedbackFloatingFloatingActionButtonStyle, "data-tb-test-id": TestIds_1.EDITOR_SUBMIT_FEEDBACK_TEST_ID, onClick: function () { return openFeedbackWindow(); }, onKeyPress: function () { return openFeedbackWindow(); }, role: "button", tabIndex: 0 },
            React.createElement(MegaphoneAnnounce_1.MegaphoneAnnounce, null),
            Localize_1.Messages.submitFeedbackButton()));
    };
    var confirmNewVersion = function () { return __awaiter(void 0, void 0, void 0, function () {
        var result, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (0, Index_1.showQuestionDialog)(Localize_1.Messages.simpleDialogCreate(), Localize_1.Messages.versionLockedConfirmMessage(), Localize_1.Messages.simpleDialogCreate(), widgets_1.ButtonType.Destructive)];
                case 1:
                    result = _a.sent();
                    if (!(result === Index_1.DialogButtonResult.OK)) return [3 /*break*/, 6];
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 5, , 6]);
                    return [4 /*yield*/, thunkDispatch((0, PredictiveModelThunk_1.getNextModelVersion)()).unwrap()];
                case 3:
                    _a.sent();
                    return [4 /*yield*/, thunkDispatch((0, PredictiveModelThunk_1.getRecentTrainingJob)()).unwrap()];
                case 4:
                    _a.sent();
                    return [3 /*break*/, 6];
                case 5:
                    err_1 = _a.sent();
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var showAlertOverlay = function (training, succeededTraining, subspace, prepStatus) {
        if (training || succeededTraining) {
            return subspace === Utils_1.SubspaceType.Connect || subspace === Utils_1.SubspaceType.Define;
        }
        else if (prepStatus !== Utils_1.PrepDataSourceStatus.none) {
            return selectSubspace === Utils_1.SubspaceType.Define || selectSubspace === Utils_1.SubspaceType.Train;
        }
        return false;
    };
    var getAlertOverlayMessage = function (training, succeededTraining, modelVersion, job, prepStatus) {
        if (training) {
            return Localize_1.Messages.trainingInProgressAlertMessage();
        }
        else if (succeededTraining) {
            return Localize_1.Messages.versionLockedAlertMessage({
                version: modelVersion.versionNumber,
                date: new Date(job.jobStart).toLocaleString(),
                user: userName,
            });
        }
        else if (prepStatus === Utils_1.PrepDataSourceStatus.flowNotPublished || prepStatus === Utils_1.PrepDataSourceStatus.columnsNotReceived) {
            return Localize_1.Messages.trainObjectiveWaitForFlowPublishInfo();
        }
        else if (prepStatus === Utils_1.PrepDataSourceStatus.connectionError) {
            return Localize_1.Messages.prepConnectionError();
        }
        else if (prepStatus === Utils_1.PrepDataSourceStatus.columnSizeError) {
            return Localize_1.Messages.prepColumnSizeError();
        }
        return '';
    };
    var getOverlayButton = function (succeededTraining) {
        if (succeededTraining) {
            return (React.createElement(widgets_1.ButtonWidget, { buttonType: widgets_1.ButtonType.Outline, onClick: function () { return confirmNewVersion(); } }, Localize_1.Messages.versionLockedEditButton()));
        }
        return undefined;
    };
    var getInlineAlertType = function (succeededTraining, training, prepStatus) {
        if (succeededTraining || training) {
            return widgets_1.InlineAlertType.Warning;
        }
        else if (prepStatus === Utils_1.PrepDataSourceStatus.columnSizeError || prepStatus === Utils_1.PrepDataSourceStatus.connectionError) {
            return widgets_1.InlineAlertType.Error;
        }
        return widgets_1.InlineAlertType.Info;
    };
    var renderOverlay = function () {
        if (!showAlertOverlay(modelTraining, modelSucceededTraining, selectSubspace, prepDataSourceStatus)) {
            return null;
        }
        return (React.createElement("div", { className: styles.predictiveModelAlertContainerStyle },
            React.createElement("div", { className: styles.predictiveModelAlertStyle },
                React.createElement(widgets_1.InlineAlertWidget, { button: getOverlayButton(modelSucceededTraining), type: getInlineAlertType(modelSucceededTraining, modelTraining, prepDataSourceStatus), testId: TestIds_1.EDITOR_OVERLAY_ALERT_TEST_ID },
                    React.createElement("span", null, getAlertOverlayMessage(modelTraining, modelSucceededTraining, model.activeVersion, job, prepDataSourceStatus))))));
    };
    return (React.createElement(NavigationContext_1.NavigationProvider, null,
        React.createElement("div", { className: styles.predictiveModelEditorRow },
            React.createElement(PrometheusEditorHeader_1.PrometheusEditorHeader, null),
            React.createElement("div", { className: styles.predictiveModelEditorMain },
                renderOverlay(),
                renderSubspaceConnectComponent(selectSubspace),
                renderSubspaceNonConnectComponent(selectSubspace),
                renderSubmitFeedbackButton()))));
};
exports.PrometheusEditorContainer = PrometheusEditorContainer;
//# sourceMappingURL=PrometheusEditorContainer.js.map